import React from 'react'
import { useState } from 'react'
import { useEffect } from 'react'
import axios from "axios"

function ThankYouConsent({ serverURL }) {

    const [showConsented, setShowConsented] = useState(false)
    const [message, setMessage] = useState(false)
    const saveResponse = async () => {
        const url = window.location.href
        const consentId = url.split("consent/")[1]


        const findAndUpdateTheConsent = await axios.post(serverURL + "/consent/verify", { "consentId": consentId })
        if (findAndUpdateTheConsent.status === 200) {
            setShowConsented(true)
            setMessage("✅ Thank you! Your consent has been recorded. We will proceed with further processing.")
        } else {
            setShowConsented(true)
            setMessage(findAndUpdateTheConsent.data)
            console.log(findAndUpdateTheConsent.data)
            window.close()
        }
    }

    useEffect(() => {
        saveResponse()
    }, [])
    return (
        <>
            {
                showConsented &&
                (
                    <div className='vh-100 vw-100 d-flex align-items-center justify-content-center'>
                        <div id="thankyou-message" style={{ backgroundColor: "#d4edda", color: "#155724", padding: "15px", borderRadius: "5px" }}>
                            {message}
                        </div>
                    </div>
                )
            }
        </>
    )
}

export default ThankYouConsent